import { memo, useCallback, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { ReassignmentItem } from 'clickNgo/features/contact/contactReassignment'
import { Nullable } from 'cng-common/models/utils'

import { ContactRelinkingStep } from '../../../configs'
import { useReassignment } from '../../../contexts/ReassignmentContext'
import { ContactRelinkingStepProps } from '../../../models'
import { contactRelinkingModalTranslations } from '../../../translation'
import { Reassignment } from '../../reassignment'

export const ReassignRolesStep = memo<ContactRelinkingStepProps>(({ onCancel, onProceed }) => {
  const { rolesToReassign, flagsToReassign, updateRoleAssignment, availableContacts } =
    useReassignment()

  const items: ReassignmentItem[] = useMemo(
    () =>
      rolesToReassign.map((role) => ({
        key: role.role,
        displayName: role.role,
        contact: role.contact || null,
      })),
    [rolesToReassign]
  )

  const handleProceedClick = useCallback(() => {
    if (flagsToReassign.length > 0) {
      onProceed(ContactRelinkingStep.ReassignFlags)
    } else {
      onProceed(ContactRelinkingStep.Completion)
    }
  }, [flagsToReassign.length, onProceed])

  const handleRoleChange = useCallback(
    (roleKey: string, contact: Nullable<IContact>) => {
      updateRoleAssignment(roleKey, contact)
    },
    [updateRoleAssignment]
  )

  return (
    <Reassignment
      title={contactRelinkingModalTranslations.reassignRolesStep.title}
      description={contactRelinkingModalTranslations.reassignRolesStep.description}
      warningMsg={
        availableContacts.length
          ? contactRelinkingModalTranslations.reassignRolesStep.warning
          : contactRelinkingModalTranslations.reassignRolesStep.notAvailableContacts
      }
      items={items}
      onItemChange={handleRoleChange}
      onCancel={onCancel}
      onProceed={handleProceedClick}
      isSkippable
    />
  )
})

ReassignRolesStep.displayName = 'ReassignRolesStep'
